import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the HttpFormatPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'httpFormat',
})
export class HttpFormatPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    // return value.toLowerCase();
    if(typeof value == 'string'){
      var re = /(\(.*?)?\b((?:https?|ftp|file):\/\/[-a-z0-9+&@#\/%?=~_()|!:,.;]*[-a-z0-9+&@#\/%=~_()|])/ig;
      return value.replace(re, (match, lParens, url) => {
        var rParens = '';
        lParens = lParens || '';

        // Try to strip the same number of right parens from url
        // as there are left parens.  Here, lParenCounter must be
        // a RegExp object.  You cannot use a literal
        //     while (/\(/g.exec(lParens)) { ... }
        // because an object is needed to store the lastIndex state.
        let lParenCounter = /\(/g;
        while (lParenCounter.exec(lParens)) {
          var m;
          // We want m[1] to be greedy, unless a period precedes the
          // right parenthesis.  These tests cannot be simplified as
          //     /(.*)(\.?\).*)/.exec(url)
          // because if (.*) is greedy then \.? never gets a chance.
          if (m = /(.*)(\.\).*)/.exec(url) ||
              /(.*)(\).*)/.exec(url)) {
            url = m[1];
            rParens = m[2] + rParens;
          }
        }
        return lParens + "<a href='" + url + "'>" + url + "</a>" + rParens;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/http-format/http-format.ts